import React from 'react';
import { StarIcon } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function TrustBar() {
  return <div className="border-y border-divider bg-cream-dark/30" data-id="element-222">
      <div className="container mx-auto px-4 py-6" data-id="element-223">
        <FadeIn delay={200} direction="none" data-id="element-224">
          <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 text-sm font-medium text-foreground/80 tracking-wide" data-id="element-225">
            <div className="flex items-center gap-1 text-gold" data-id="element-226">
              {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} fill="currentColor" data-id="element-227" />)}
            </div>
            <span className="hidden md:inline text-divider" data-id="element-228">|</span>
            <span data-id="element-229">250+ Reviews</span>
            <span className="hidden md:inline text-divider" data-id="element-230">|</span>
            <span data-id="element-231">4.9 Stars</span>
            <span className="hidden md:inline text-divider" data-id="element-232">|</span>
            <span data-id="element-233">San Ramon, CA</span>
          </div>
        </FadeIn>
      </div>
    </div>;
}